<template>
  <gjw-dialog
      :show-dialog="showDialog"
      title="选择模型文件"
      :config="{ width:'600px', class: 'has-footer-border body-no-padding', showFooter: false}"
      @close="closeDialog"
  >
    <div>
      <div class="tip-line">
        <i class="iconfont icon-tishi ft-theme mg-rt-md"></i>
        <span>仅支持选择当前启用版本轻量化转换成功的文件。</span>
      </div>
      <div class="file-tree">
        <el-tree
          v-if="showDialog"
          :data="treeData"
          :props="treeProps"
          show-checkbox
          node-key="id"
          :default-expanded-keys="defaultExpandedKeys"
          @check="handleCheckNode"
        >
          <template #default="{ node, data }">
            <div class="tree-node">
              <img v-if="data.isFolder" class="iconfont icon-wenjianjia-gongkai folder-img" src="~@/assets/img/wenjianjia.png" style="margin-right: 6px;" alt="" />
              <img v-else class="file-img" :src="getFileIcon(data.suffix)" style="margin-right: 6px;" alt="" />
              <span class="ellipsis-text" :title="formatName(data)"> {{ formatName(data) }} </span>
            </div>
          </template>
        </el-tree>
      </div>
      <div class="footer">
        <div class="info-text">
          <span>已选: <span :class="{'ft-red': selectedCount > 100}">{{ selectedCount }}</span></span>
          <span class="mg-lt-md">剩余可选: {{ remainingCount }}</span>
        </div>
        <div>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" :loading="loading" :disabled="!selectedCount" @click="confirmOk">确定</el-button>
        </div>
      </div>
    </div>
  </gjw-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import openUrlMixin from '@/mixins/openUrlMixin'
import { updateFederationErrorCodeMap } from '@/views/file/errorCodeMap'

export default {
  name: 'CreateEditPlan',
  props: {
    // create: 新建；edit：编辑；
    operate: {
      type: String,
      default: 'create'
    },
    // checkedFiles: 已选文件
    checkedFiles: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mixins: [openUrlMixin],
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      editPlanId: '',
      showDialog: false,
      loading: false,
      selectedFiles: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
    }
  },
  computed: {
    ...mapGetters({
      federationPlanFileTree: 'fileModel/federationPlanFileTree',
      federationPlanEditFileTree: 'fileModel/federationPlanEditFileTree',
    }),
    treeData() {
      return this.operate === 'edit' ? this.federationPlanEditFileTree : this.federationPlanFileTree
    },
    defaultExpandedKeys() {
      const keys = []
      if (this.treeData.length) {
        keys.push(this.treeData[0].id)
      }
      return keys
    },
    getFileIcon() {
      return (type) => require(`@/assets/file/${type || 'default'}.png`)
    },
    selectedCount() {
      return this.selectedFiles.length
    },
    remainingCount() {
      const count = 100 - this.selectedFiles.length - this.checkedFiles.length
      return count > 0 ? count : 0
    },
  },
  methods: {
    ...mapActions({
      loadAllFederationPlanFiles: 'fileModel/loadAllFederationPlanFiles',
    }),
    formatName(data) {
      return data.suffix ? `${data.name}.${data.suffix}` : `${data.name}`
    },
    openDialog(planId) {
      this.showDialog = true
      this.editPlanId = planId
      this.loadAllFederationPlanFiles(this.spaceId)
    },
    closeDialog() {
      this.loading = false
      this.selectedFiles = []
      this.showDialog = false
    },
    handleCheckNode(data, { checkedNodes }) {
      this.selectedFiles = checkedNodes.filter((item) => !item.isFolder).map((item) => item.id)
    },
    confirmOk() {
      const checkedFileIds = this.checkedFiles.map((f) => f.fileId)
      const fileIds = [...checkedFileIds, ...this.selectedFiles]
      if (fileIds.length > 100) {
        this.$message.error('每个方案最多选择100个文件')
        return
      }
      this.loading = true
      if (this.operate === 'create') {
        // 新建合模方案
        this.$api.file.checkFederationPlan(this.spaceId, fileIds).then((data) => {
          const fileItems = data.fileItems || []
          const operationKey = data.operationKey
          const failFiles = fileItems.filter((f) => f.checkStatus !== 'NORMAL') || []
          if (failFiles.length) {
            const errFile = failFiles[0]
            const errFileName = errFile.suffix ? `${errFile.fileName}.${errFile.suffix}` : errFile.fileName
            this.$confirm(`${errFileName}等${failFiles.length}个文件发生了变动，暂不支持合模，请重新选择。`, {
              confirmButtonText: '确定',
              showCancelButton: false,
              showClose: false,
              type: 'error',
            }).then(() => {
              this.loading = false
            })
          } else {
            // 携带operationKey，跳到预览页面
            const preview = this.$router.resolve({
              name: 'FederationPlanPreview',
              params: { spaceId: this.spaceId },
              query: {
                key: operationKey,
              }
            })
            const preViewUrl = `${process.env.VUE_APP_PROJECT_HOST}${preview.href}`
            // console.log('预览地址：', preViewUrl)
            this.openUrl(preViewUrl, true, '_blank')
            this.$tracks({
              event: 'newFederatedPlan',
              params: {
                g_c_space_id: this.spaceId
              }
            })
            this.closeDialog()
          }
        }).catch((err) => {
          this.loading = false
          this.$matchError(err.code, updateFederationErrorCodeMap, '新建合模方案失败')
        })
      } else {
        // 编辑合模方案
        this.$api.file.updateFederationPlanFile(this.spaceId, this.editPlanId, fileIds).then((data) => {
          if (data.isSuccess) {
            this.$emit('edited')
            this.closeDialog()
          } else {
            const fileItems = data.fileItems || []
            const failFiles = fileItems.filter((f) => f.checkStatus !== 'NORMAL') || []
            const errFile = failFiles[0]
            const errFileName = errFile.suffix ? `${errFile.fileName}.${errFile.suffix}` : errFile.fileName
            this.$confirm(`${errFileName}等${failFiles.length}个文件发生了变动，暂不支持合模，请重新选择。`, {
              confirmButtonText: '确定',
              showCancelButton: false,
              showClose: false,
              type: 'error',
            }).then(() => {
              this.loading = false
            })
          }
        }).catch((err) => {
          this.loading = false
          this.$matchError(err.code, updateFederationErrorCodeMap, '添加模型失败')
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.tip-line{
  background: #E6F7FF;
  border: 1px solid #91D5FF;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
}
.file-tree{
  height: 410px;
  overflow-y: auto;
  padding: 4px 20px;
}
.footer{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #E6E6E6;
}
.tree-node{
  display: flex;
  align-items: center;
  font-size: 1rem;
}
.folder-img{
  width: 16px;
  height: 16px;
}
.file-img{
  width: 16px;
  height: 16px;
}

</style>
